<template>
  <b-row>
    <b-col cols="12">

      <step :ComponentName="'servicecentercomplaint'"
      />

    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import step from '../forms/step.vue'

export default {
  components: {
    BRow,
    BCol,
    step,
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
